<template>
  <div class="container mt-5">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/dashboard">Dashboard</router-link></li>
        <li class="is-active">
          <router-link to="/dashboard/report" aria-current="true">Defect Tracker</router-link>
        </li>
      </ul>
    </nav>

    <div class="columns">
      <!-- Filter Tabs -->
      <!-- Status Tabs -->
      <div class="tabs is-toggle is-small mb-2 column is-4">
        <ul>
          <li :class="{ 'is-active': statusFilter === 'open' }">
            <a @click="setStatusFilter('open')">Open</a>
          </li>
          <li :class="{ 'is-active': statusFilter === 'closed' }">
            <a @click="setStatusFilter('closed')">Closed</a>
          </li>
          <li :class="{ 'is-active': statusFilter === 'all' }">
            <a @click="setStatusFilter('all')">All Status</a>
          </li>
        </ul>
      </div>

      <!-- Category Tabs -->
      <div class="tabs is-toggle is-small mb-4 column is-4">
        <ul>
          <li :class="{ 'is-active': categoryFilter === 'all' }">
            <a @click="setCategoryFilter('all')">All Categories</a>
          </li>
          <li :class="{ 'is-active': categoryFilter === 'Defect' }">
            <a @click="setCategoryFilter('Defect')">Defect</a>
          </li>
          <li :class="{ 'is-active': categoryFilter === 'Enhancement' }">
            <a @click="setCategoryFilter('Enhancement')">Enhancement</a>
          </li>
          <li :class="{ 'is-active': categoryFilter === 'Clarification' }">
            <a @click="setCategoryFilter('Clarification')">Clarification</a>
          </li>
        </ul>
      </div>

      <div class="is-small column is-1">
        <div class="select is-small mr-3">
          <select v-model="pageSize" @change="handlePageSizeChange">
            <option :value="50">50 per page</option>
            <option :value="100">100 per page</option>
            <option :value="200">200 per page</option>
          </select>
        </div>
      </div>

      <div class="mb-4 column is-1">
        <button class="button is-small is-info" @click="downloadDefectReport">
          Report
        </button>
      </div>

      <div class="mb-4 column is-2">
        <button class="button is-small is-primary" @click="openModalForCreate">
          + New Defect
        </button>
      </div>
    </div>

    <div class="columns is-multiline mb-4 is-small">

      <!-- Show My Defects Checkbox -->
      <div class="column is-2 is-vcentered">
        <label class="checkbox">
          <input
            type="checkbox"
            v-model="showMyDefects"
            @change="onShowMyDefectsChange"
          />
          Show Only My Defects
        </label>
      </div>
    </div>

    

    <div class="table-container content is-small">
      <table class="table is-hoverable is-striped is-fullwidth">
        <thead class="">
          <tr>
            <th @click="changeSort('defect_number')">
              Defect #
              <span v-if="sortBy === 'defect_number'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="changeSort('category')">
              Category
              <span v-if="sortBy === 'category'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="changeSort('defect_description')">
              Description
              <span v-if="sortBy === 'defect_description'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="changeSort('status')">
              Status
              <span v-if="sortBy === 'status'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="changeSort('severity')">
              Severity
              <span v-if="sortBy === 'severity'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="changeSort('category')">
              Latest Update
              <span v-if="sortBy === 'category'"></span>
            </th>
            <th @click="changeSort('updated_at')">
              Created By
              <span v-if="sortBy === 'created_by'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="changeSort('detected_on')">
              Detected On
              <span v-if="sortBy === 'detected_on'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="changeSort('created_at')">
              Created
              <span v-if="sortBy === 'created_at'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="changeSort('created_at')">
              Dev Due Date
              <span v-if="sortBy === 'dev_due_date'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="changeSort('updated_at')">
              Last Updated
              <span v-if="sortBy === 'updated_at'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
            </th>

          </tr>
        </thead>
        <tbody>
          <tr
            v-for="defect in defects"
            :key="defect.id"
            @click="openModalForEdit(defect)"
            style="cursor: pointer;"
          >
            <td><strong>{{ defect.defect_number }}</strong></td>
            <td>{{ defect.category }}</td>
            <td>{{ defect.defect_description.substring(0, 60) }}...</td>
            <td>
              <span class="tag is-light is-info">{{ defect.status }}</span>
            </td>
            <td>
              <span :class="['tag', severityClass(defect.severity)]">
                {{ defect.severity }}
              </span>
            </td>
            <td>{{ defect.last_comment || '—' }}</td>
            <td>{{ defect.created_by_name || '—' }}</td>
            <td>{{ defect.detected_on || '—' }}</td>
            <td>{{ new Date(defect.created_at).toLocaleString() }}</td>
            <td>{{ defect.dev_due_date || '—' }}</td>
            <td>{{ new Date(defect.updated_at).toLocaleString() }}</td>

          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-4 mb-4">
      <nav class="pagination is-centered is-small" role="navigation" aria-label="pagination">
        <a class="pagination-previous" @click="prevPage" :disabled="page === 1">Previous</a>
        <ul class="pagination-list">
          <li v-for="n in totalPages" :key="n">
            <a class="pagination-link" :class="{ 'is-current': n === page }" @click="goToPage(n)">
              {{ n }}
            </a>
          </li>
        </ul>
        <a class="pagination-next" @click="nextPage" :disabled="page === totalPages">Next</a>
      </nav>
    </div>

    <!-- Unified Modal for Create and Edit -->
    <div class="modal" :class="{ 'is-active': modalActive }">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card" :style="{ width: '50%', maxWidth: '700px', height: '85%' }">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <span v-if="isEditMode">Edit Defect - {{ form.defect_number }}</span>
            <span v-else>New Defect</span>
          </p>
          <button class="delete" aria-label="close" @click="closeModal"></button>
        </header>
        <section class="modal-card-body">
          <form @submit.prevent="handleSubmit">
            <!-- Screenshot Preview Section (common to both create and edit) -->
            <div v-if="form.screenshotPreview" class="mb-4">
              <figure class="image screenshot-preview">
                <img
                  :src="form.screenshotPreview"
                  alt="Screenshot Preview"
                  @click="openImageModal(form.screenshotPreview)"
                  class="clickable-image"
                />
              </figure>

              <button type="button" class="button is-small is-danger mt-2" @click="removeScreenshot">
                Remove Image
              </button>
            </div>

            <!-- Mode-specific Fields -->
            <template v-if="!isEditMode">
              <div class="field">
                <label class="label">Defect Description</label>
                <div class="control">
                  <textarea v-model="form.defect_description" class="textarea" required></textarea>
                </div>
              </div>
              <div class="field">
                <label class="label">Severity</label>
                <div class="control">
                  <div class="select">
                    <select v-model="form.severity">
                      <option value="low">Low</option>
                      <option value="medium">Medium</option>
                      <option value="high">High</option>
                      <option value="critical">Critical</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="columns is-multiline">
                <!-- <div class="column is-half">
                  <div class="field">
                    <label class="label">Sprint Number</label>
                    <div class="control">
                      <div class="select">
                        <select v-model="form.sprint_number">
                          <option value="Batch 1">Batch 1</option>
                          <option value="Batch 2">Batch 2</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div> -->
                <div class="column is-half">
                  <div class="field">
                    <label class="label">Assigned To</label>
                    <div class="control">
                      <div class="select">
                        <select v-model="form.assigned_to">
                          <option value="USER">USER</option>
                          <option value="DESPAQ">DESPAQ</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="column is-half">
                  <div class="field">
                    <label class="label">BRD ID</label>
                    <div class="control">
                      <input v-model="form.brd_id" class="input" placeholder="Optional" />
                    </div>
                  </div>
                </div> -->
                <!-- <div class="column is-full">
                  <div class="field">
                    <label class="label">BRD Description</label>
                    <div class="control">
                      <textarea v-model="form.brd_description" class="textarea" placeholder="Optional"></textarea>
                    </div>
                  </div>
                </div> -->
              </div>
            </template>

            <template v-else>
              <div class="field">
                <label class="label">Description</label>
                <div class="control">
                  <!-- Read-only defect description -->
                  <textarea v-model="form.defect_description" class="textarea" :readonly="!isSuperAdmin"></textarea>
                </div>
              </div>
              <div class="field">
                <label class="label">Status</label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="form.status">
                      <option value="new">New</option>
                      <option value="assigned">Assigned</option>
                      <option value="in-progress">In Progress</option>
                      <option value="fixed">Fixed</option>
                      <option value="retest">Retest</option>
                      <option value="closed">Closed</option>
                      <option value="rejected">Rejected</option>
                      <option value="deferred">Deferred</option>
                      <option value="awaiting-clarificaton">Awaiting Clarification</option>
                      <option value="enhancement">Enhacement</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Add Comment</label>
                <div class="control">
                  <input v-model="newComment" class="input" placeholder="Write a comment..." />
                </div>
              </div>
              <div class="field mt-4">
                <label class="label">Comment History</label>
                <div v-if="form.comments && form.comments.length">
                  <div v-for="c in form.comments" :key="c.id" class="box is-light">
                    <p>
                      <strong>{{ c.commenter_name }}</strong>
                      — <em>{{ new Date(c.created_at).toLocaleString() }}</em>
                    </p>
                    <p>{{ c.comment }}</p>
                  </div>
                </div>
                <p v-else>No comments yet.</p>
              </div>
              <div class="columns is-multiline">
                <div
                  class="column is-half"
                  v-for="(fieldKey, fieldName) in {
                    // 'Sprint Number': 'sprint_number',
                    // 'BRD ID': 'brd_id',
                    // 'BRD Description': 'brd_description',
                    'Tester Comments': 'tester_comments',
                    'Tested By': 'tested_by',
                    'Dev Due Date': 'dev_due_date',
                    'Assigned To': 'assigned_to',
                    'Closing Date': 'closing_date',
                    'Root Cause': 'root_cause',
                    // 'Other Root Cause': 'other_root_cause',
                    'Resolution': 'resolution'
                  }"
                  :key="fieldName"
                >
                  <div class="field">
                    <label class="label">{{ fieldKey }}</label>
                    <div class="control">
                      <!-- Sprint Number dropdown -->
                      <!-- <template v-if="fieldName === 'sprint_number'">
                        <div class="select">
                          <select v-model="form.sprint_number" :disabled="!isSuperAdmin">
                            <option value="Batch 1">Batch 1</option>
                            <option value="Batch 2">Batch 2</option>
                          </select>
                        </div>
                      </template> -->

                      <!-- Assigned To dropdown -->
                      <template v-if="fieldName === 'assigned_to'">
                        <div class="select">
                          <select v-model="form.assigned_to" :disabled="!isSuperAdmin">
                            <option value="USER">USER</option>
                            <option value="DESPAQ">DESPAQ</option>
                          </select>
                        </div>
                      </template>

                      <!-- All other fields stay as inputs -->
                      <template v-else>
                        <input
                          v-model="form[fieldName]"
                          class="input"
                          :readonly="!isSuperAdmin"
                        />
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <!-- Common Fields for both modes -->
            <div class="field">
              <label class="label">
                <span v-if="isEditMode">Change Screenshot</span>
                <span v-else>Attach Screenshot</span>
              </label>
              <div class="control">
                <input type="file" @change="handleFileUpload" class="input" accept="image/*" />
              </div>
            </div>
            <div v-if="isEditMode && form.file_download_url" class="field">
              <label class="label">Existing Attachment</label>
              <div class="control">
                <a :href="form.file_download_url" target="_blank" class="has-text-link">
                  <font-awesome-icon icon="download" class="mr-2" />
                  {{ form.file_upload_name || 'Download attachment' }}
                </a>
              </div>
            </div>

            <div class="field">
              <label class="label">
                <span v-if="isEditMode">Change Attachment</span>
                <span v-else>Attach File</span>
              </label>
              <div class="control">
                <input type="file" @change="handleGenericFileUpload" class="input" />
              </div>
            </div>

            <div class="field">
              <label class="label">Category</label>
              <div class="control">
                <div class="select">
                  <select v-model="form.category">
                    <option value="Defect">Defect</option>
                    <option value="Enhancement">Enhancement</option>
                    <option value="Clarification">Clarification</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="field">
              <label class="label">Detected On</label>
              <div class="control">
                <input type="date" v-model="form.detected_on" class="input" />
              </div>
            </div>

            <div class="control">
              <button class="button is-primary" type="submit">
                {{ isEditMode ? 'Save changes' : 'Submit' }}
              </button>
            </div>
          </form>
        </section>
      </div>
    </div>

    <div class="modal" :class="{ 'is-active': showImageModal }">
      <div class="modal-background" @click="closeImageModal"></div>
      <div class="modal-content has-text-centered">
        <img :src="modalImageUrl" class="modal-enlarged-image" :style="{ width: '90%' }" />
      </div>
      <button class="modal-close is-large" aria-label="close" @click="closeImageModal"></button>
    </div>


  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { faFile } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { toast } from 'bulma-toast';
import axios from 'axios';

library.add(faDownload, faFile)

export default {
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      showImageModal: false,
      modalImageUrl: '',
      defects: [],
      modalActive: false,
      newComment: '',
      statusFilter: 'open',      // 'open' | 'closed' | 'rejected' | 'all'
      categoryFilter: 'all',     // 'Defect' | 'Enhancement' | 'Clarification' | 'all'
      sortBy: 'created_at',
      sortOrder: 'desc', // or 'asc'
      createdByEmail: '',  // Email filter for 'Created By'
      showMyDefects: false, // To filter by current user's defects
      page: 1,
      totalPages: 1,
      totalDefects: 0,
      pageSize: 50,
      // Unified form, including properties for screenshot file and preview
      form: {
        id: null,
        defect_number: '',
        defect_description: '',
        severity: 'low',
        category: 'UI',
        detected_on: new Date().toISOString().substr(0, 10),
        status: 'new',
        sprint_number: '',
        brd_id: '',
        brd_description: '',
        tester_comments: '',
        tested_by: '',
        dev_due_date: '',
        assigned_to: '',
        closing_date: '',
        root_cause: '',
        other_root_cause: '',
        resolution: '',
        screenshot: null,
        screenshotPreview: '',
        file_upload: null,
        file_upload_name: '',
        file_download_url: '',
        comments: [],
        created_at: '',
        updated_at: '',
        created_by: '',
      },  
    };
  },
  computed: {
    isEditMode() {
      return this.form.id !== null;
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
  },
  mounted() {
    this.fetchDefects();
  },
  methods: {
    onShowMyDefectsChange() {
      this.page = 1;           // reset to first page, if you like
      this.fetchDefects();
    },
    openImageModal(url) {
      this.modalImageUrl = url;
      this.showImageModal = true;
    },
    closeImageModal() {
      this.showImageModal = false;
      this.modalImageUrl = '';
    },

    handlePageSizeChange() {
      this.page = 1;
      this.fetchDefects();
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.fetchDefects();
      }
    },
    nextPage() {
      if (this.page < this.totalPages) {
        this.page++;
        this.fetchDefects();
      }
    },
    goToPage(n) {
      this.page = n;
      this.fetchDefects();
    },
    setStatusFilter(status) {
      this.statusFilter = status;
      this.fetchDefects();
    },

    setCategoryFilter(category) {
      this.categoryFilter = category;
      this.fetchDefects();
    },
    changeSort(column) {
      if (this.sortBy === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortBy = column;
        this.sortOrder = 'asc';
      }
      this.fetchDefects();
    },
    async downloadDefectReport() {
      try {
        const response = await axios.get('api/v1/support/export/', {
          responseType: 'blob'
        });
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'defect_report.xlsx';
        link.click();
      } catch (error) {
        console.error('Download failed:', error);
        toast({
          message: 'Error downloading defect report. Please try again.',
          type: 'is-danger',
          dismissible: true,
          duration: 5000,
          position: 'top-right'
        });
      }
    },
    async fetchDefects() {
      const params = {
        page: this.page,
        page_size: this.pageSize,
        ordering: (this.sortOrder === 'desc' ? '-' : '') + this.sortBy,
      };

      // Handling status filter (include specific statuses)
      if (this.statusFilter !== 'all') {
        if (this.statusFilter === 'open') {
          // For "open", include statuses like new, assigned, etc.
          params.status = 'new,assigned,in-progress,fixed,retest,reopened,awaiting-clarificaton'; // Example statuses for "open"
        } else if (this.statusFilter === 'closed') {
          // For "closed", include statuses like closed, deferred, enhancement
          params.status = 'closed,deferred,enhancement,deferred,duplicate,not_a_defect,rejected';
        } else if (this.statusFilter === 'rejected') {
          // For "rejected", only include rejected
          params.status = 'rejected';
        } else {
          // For other statuses, pass them directly
          params.status = this.statusFilter;
        }
      }

      if (this.categoryFilter !== 'all') {
        params.category = this.categoryFilter;
      }

      if (this.createdByEmail) {
        params.created_by_email = this.createdByEmail;
      }

      if (this.showMyDefects) {
        params.created_by_email = this.$store.state.user.email; // Assuming you have current user email in store
      }

      try {
        const response = await axios.get('api/v1/support/defects/', { params });
        this.defects = response.data.results;
        this.totalDefects = response.data.count || 0;
        this.totalPages = Math.max(1, Math.ceil(this.totalDefects / this.pageSize || 1));
      } catch (error) {
        console.error('Failed to fetch defects:', error);
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.form.screenshot = file;
        const reader = new FileReader();
        reader.onload = e => {
          this.form.screenshotPreview = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.form.screenshot = null;
        this.form.screenshotPreview = '';
      }
    },
    handleGenericFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.form.file_upload = file;
        const reader = new FileReader();
        reader.readAsDataURL(file);
      } else {
        this.form.file_upload = null;
        this.form.file_download_url = '';
      }
    },
    removeScreenshot() {
      this.form.screenshot = null;
      this.form.screenshotPreview = '';
    },
    openModalForCreate() {
      // Reset form for creation
      this.form = {
        id: null,
        defect_number: '',
        defect_description: '',
        severity: 'low',
        category: 'Defect',
        detected_on: '',
        sprint_number: '',     // <— add this
        brd_id: '',            // <— add this
        brd_description: '',   // <— add this
        screenshot: null,
        screenshotPreview: '',
        status: 'New',
        comments: [],
      };
      this.newComment = '';
      this.modalActive = true;
    },
    openModalForEdit(defect) {
      // Populate the form with data from the defect.
      // If a screenshot URL is available, assign it to screenshotPreview to display it.
      this.form = {
        ...this.form,
        id: defect.id,
        defect_number: defect.defect_number,
        defect_description: defect.defect_description,
        severity: defect.severity,
        category: defect.category,
        detected_on: defect.detected_on,
        status: defect.status,
        sprint_number: defect.sprint_number,
        brd_id: defect.brd_id,
        brd_description: defect.brd_description,
        tester_comments: defect.tester_comments,
        tested_by: defect.tested_by,
        dev_due_date: defect.dev_due_date,
        assigned_to: defect.assigned_to,
        closing_date: defect.closing_date,
        root_cause: defect.root_cause,
        other_root_cause: defect.other_root_cause,
        resolution: defect.resolution,
        screenshot: null,
        screenshotPreview: defect.screenshot || '',
        file_upload: null,
        file_upload_name: defect.file_upload?.split('/').pop() || '',
        file_download_url: defect.file_upload || '',
        comments: defect.comments || [],
        created_at: defect.created_at,
        updated_at: defect.updated_at,
        created_by: defect.created_by
      };
      this.newComment = '';
      this.modalActive = true;
    },
    async handleSubmit() {
      if (!this.isEditMode) {
        // Create new defect
        const formData = new FormData();
        formData.append('defect_description', this.form.defect_description);
        formData.append('severity', this.form.severity);
        formData.append('category', this.form.category);
        formData.append('detected_on', this.form.detected_on);
        if (this.form.sprint_number) formData.append('sprint_number', this.form.sprint_number);
        if (this.form.brd_id) formData.append('brd_id', this.form.brd_id);
        if (this.form.brd_description) formData.append('brd_description', this.form.brd_description);
        if (this.form.screenshot) {
          formData.append('screenshot', this.form.screenshot);
        }
        if (this.form.file_upload) {
          formData.append('file_upload', this.form.file_upload);
        }
        try {
          await axios.post('api/v1/support/defects/', formData);
          toast({
          message: 'Defect created successfully!',
          type: 'is-success',
          dismissible: true,
          duration: 5000,
          position: 'top-right'
        });
        } catch (error) {
          console.error('Error creating defect:', error);
          toast({
            message: 'Error creating defect. Please try again.',
            type: 'is-danger',
            dismissible: true,
            duration: 5000,
            position: 'top-right'
          });
          return;
        }
      } else {
        // Update existing defect
        const patchData = {
          status: this.form.status,
          category: this.form.category,
          detected_on: this.form.detected_on,
        };

        // Use FormData if either screenshot or file_upload is updated
        const hasScreenshot = !!this.form.screenshot;
        const hasFileUpload = !!this.form.file_upload;

        if (hasScreenshot || hasFileUpload) {
          const formData = new FormData();
          for (let key in patchData) {
            formData.append(key, patchData[key]);
          }
          if (hasScreenshot) {
            formData.append('screenshot', this.form.screenshot);
          }
          if (hasFileUpload) {
            formData.append('file_upload', this.form.file_upload);
          }
          try {
            await axios.patch(`api/v1/support/defects/${this.form.id}/`, formData);
            toast({
              message: 'Defect updated successfully!',
              type: 'is-success',
              dismissible: true,
              duration: 5000,
              position: 'top-right'
            });
          } catch (error) {
            console.error('Error updating defect:', error);
            toast({
              message: 'Error updating defect. Please try again.',
              type: 'is-danger',
              dismissible: true,
              duration: 5000,
              position: 'top-right'
            });
            return;
          }
        }
        try {
          await axios.patch(`api/v1/support/defects/${this.form.id}/`, patchData);
          toast({
            message: 'Defect updated successfully!',
            type: 'is-success',
            dismissible: true,
            duration: 5000,
            position: 'top-right'
          });
        } catch (error) {
          console.error('Error updating defect:', error);
          toast({
            message: 'Error updating defect. Please try again.',
            type: 'is-danger',
            dismissible: true,
            duration: 5000,
            position: 'top-right'
          });
          return;
        }

        if (this.newComment) {
          await axios.post(`api/v1/support/defects/${this.form.id}/add_comment/`, {
            comment: this.newComment,
          });
        }
      }

      this.modalActive = false;
      this.fetchDefects();
    },
    closeModal() {
      this.file_upload  = '';
      this.file_upload_name = '';
      this.screenshot = '';
      this.screenshotPreview = '';
      this.modalActive = false;
    },
    severityClass(sev) {
      return {
        low: 'is-success',
        medium: 'is-warning',
        high: 'is-danger',
        critical: 'is-black',
      }[sev] || 'is-light';
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1000px;
}
.modal-card {
  width: 1000px;
  max-width: 90%;
}
.screenshot-preview img {
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  border: 1px solid #ccc;
  border-radius: 6px;
}

</style>
